'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var $ = jQuery;
var $document = $(document);
var MapService = require('./map-service.js');
var GeocodingResult = require('../geocoding-result.js');
var utils = require('../utils.js');
var RouteAnimator = require('../route-animator.js');

var MapboxGLMapService = function (_MapService) {
	_inherits(MapboxGLMapService, _MapService);

	function MapboxGLMapService($canvas, settings) {
		_classCallCheck(this, MapboxGLMapService);

		var _this2 = _possibleConstructorReturn(this, (MapboxGLMapService.__proto__ || Object.getPrototypeOf(MapboxGLMapService)).call(this, $canvas, settings));

		_this2.settings = settings;
		_this2.markers = [];
		_this2.audioUnlocked = false;
		_this2.clusterMarkers = [];
		_this2.markersContainer = [];
		_this2.$canvas = $canvas;
		_this2.type = null;
		_this2.clusteringEnabled = settings.cluster && settings.cluster.enabled;
		_this2.weatherLayers = {}; // Store weather layer references

		// Get Mapbox access token from script settings
		_this2.accessToken = window.mapsamurai_script_settings && window.mapsamurai_script_settings.mapbox_token || 'pk.eyJ1IjoianNlYXJzMzEiLCJhIjoiY21hYmNnMnJjMmF3MTJycHpwdHM4MmExMiJ9.MuKtofSbgkg5S5BtdrtMbw';

		// Check for Mapbox GL JS availability and WebGL support
		if (typeof mapboxgl === 'undefined') {
			throw new Error('Mapbox GL JS library not available');
		}

		if (!mapboxgl.supported()) {
			throw new Error('WebGL not supported');
		}

		// Set Mapbox access token
		mapboxgl.accessToken = _this2.accessToken;

		// 3D map styles
		_this2.styles = {
			'3d-standard': 'mapbox://styles/mapbox/streets-v12',
			'3d-satellite': 'mapbox://styles/mapbox/satellite-v9',
			'3d-terrain': 'mapbox://styles/mapbox/outdoors-v11',
			'3d-dark': 'mapbox://styles/mapbox/dark-v10',
			'3d-light': 'mapbox://styles/mapbox/light-v10'
		};

		// Ensure container has dimensions
		if (_this2.$canvas.width() === 0 || _this2.$canvas.height() === 0) {
			_this2.$canvas.css({
				width: '100%',
				height: '400px',
				minHeight: '300px'
			});
		}

		// Initialize Mapbox GL map with proper default zoom from settings
		_this2.map = new mapboxgl.Map({
			container: _this2.$canvas.get(0),
			style: _this2.styles['3d-standard'],
			center: [0, 0], // Will be updated by setCenter() call from Map class
			zoom: settings.zoom && settings.zoom.zoom ? settings.zoom.zoom : 2,
			pitch: 45, // 3D perspective
			bearing: 0,
			antialias: true,
			preserveDrawingBuffer: true,
			attributionControl: false, // We'll add custom attribution
			minZoom: 2, // Remove 2 furthest zoom out levels (was 0)
			maxZoom: 18 // Remove 4 closest zoom in levels (was 22)
		});

		// Add custom MapSamurai attribution
		_this2.map.addControl(new mapboxgl.AttributionControl({
			customAttribution: '© <a href="https://mapsamurai.com" target="_blank">MapSamurai</a>',
			compact: true
		}), 'bottom-right');

		// Store routes for later use
		_this2.routes = [];

		// Initialize route animator immediately
		_this2.routeAnimator = new RouteAnimator(_this2);
		_this2.routeAnimator.moveMarker = _this2.moveMarkerToPosition.bind(_this2);
		// Override the hideMarker and showMarker methods for Mapbox-specific implementation
		_this2.routeAnimator.hideMarker = _this2.hideMarkerDuringDelay.bind(_this2);
		_this2.routeAnimator.showMarker = _this2.showMarkerAfterDelay.bind(_this2);

		// Queue for animations to add after map loads
		_this2.pendingAnimations = [];

		// Initialize terrain and 3D features after map loads
		_this2.map.on('load', function () {
			_this2.setup3DFeatures();
			_this2.setupClustering();
			_this2.setupWeatherLayers(); // Add weather layers after map loads

			// Process any pending animations
			if (_this2.pendingAnimations.length > 0) {
				_this2.pendingAnimations.forEach(function (_ref) {
					var pin = _ref.pin,
					    routeWaypoints = _ref.routeWaypoints,
					    animationOptions = _ref.animationOptions;

					_this2.addAnimatedPin(pin, routeWaypoints, animationOptions);
				});
				_this2.pendingAnimations = [];
			}

			// Add routes if they were set before map loaded
			if (_this2.routes.length > 0) {
				setTimeout(function () {
					_this2.renderRoutesNow(_this2.routes);
				}, 500); // Longer delay to ensure everything is ready
			}
			// Trigger resize to ensure proper rendering
			setTimeout(function () {
				_this2.map.resize();
			}, 100);
		});

		// Add only compass control for 3D rotation (no zoom controls)
		// Position in bottom-left where Mapbox logo was
		_this2.map.addControl(new mapboxgl.NavigationControl({
			showCompass: true,
			showZoom: false,
			visualizePitch: true
		}), 'bottom-left');

		// Setup event handlers
		_this2.map.on('dblclick', function (e) {
			return $(_this2).trigger('dblclick', [e.lngLat.lat, e.lngLat.lng]);
		});

		// Temperature marker click handler
		_this2.map.on('click', function (e) {
			// Skip if clicked on a marker or cluster
			var features = _this2.map.queryRenderedFeatures(e.point, {
				layers: ['unclustered-point', 'clusters']
			});
			if (features.length > 0) return;

			$(_this2).trigger('mapsamurai.map.clicked', {
				lat: e.lngLat.lat,
				lng: e.lngLat.lng
			});
		});

		// Update marker visibility when zoom changes for clustering
		_this2.map.on('zoom', function () {
			_this2.updateMarkerVisibility();
		});

		// Also update when map finishes moving (clustering can change based on viewport)
		_this2.map.on('moveend', function () {
			_this2.updateMarkerVisibility();
		});

		// Hide tooltips only on significant map movements to avoid corruption
		_this2.map.on('dragstart', function () {
			_this2.hideAllTooltips();
		});

		// Hide tooltips when zoom changes significantly (more than 0.5 levels)
		var lastZoom = _this2.map.getZoom();
		_this2.map.on('zoomend', function () {
			var currentZoom = _this2.map.getZoom();
			if (Math.abs(currentZoom - lastZoom) > 0.5) {
				_this2.hideAllTooltips();
			}
			lastZoom = currentZoom;
		});

		_this2.$canvas.css({
			'background': _this2.settings.map.background
		});
		return _this2;
	}

	_createClass(MapboxGLMapService, [{
		key: 'setup3DFeatures',
		value: function setup3DFeatures() {
			var _this3 = this;

			try {
				// Add terrain source if it doesn't exist
				if (!this.map.getSource('mapbox-dem')) {
					this.map.addSource('mapbox-dem', {
						'type': 'raster-dem',
						'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
						'tileSize': 512,
						'maxzoom': 14
					});
				}

				// Set terrain - this triggers a style reload that wipes custom layers!
				this.map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 1.5 });

				// Re-setup clustering after terrain is set (terrain causes style reload)
				if (this.clusteringEnabled) {
					this.map.once('styledata', function () {
						_this3.setupClustering();

						// Re-add pins with clustering if we have them
						if (_this3.pins && _this3.pins.length > 0) {
							_this3.addPinsWithClustering(_this3.pins);
						}
					});
				}

				// Add sky layer if it doesn't exist
				if (!this.map.getLayer('sky')) {
					this.map.addLayer({
						'id': 'sky',
						'type': 'sky',
						'paint': {
							'sky-type': 'atmosphere',
							'sky-atmosphere-sun-intensity': 5
						}
					});
				}

				// Enable 3D buildings
				try {
					this.enable3DBuildings();
				} catch (buildingError) {}
			} catch (error) {}
		}
	}, {
		key: 'enable3DBuildings',
		value: function enable3DBuildings() {
			var _this4 = this;

			try {
				// Wait for style to load then add 3D buildings
				var addBuildingsLayer = function addBuildingsLayer() {

					// Check if buildings layer already exists
					if (_this4.map.getLayer('3d-buildings')) {
						return;
					}

					// Check available sources
					var sources = _this4.map.getStyle().sources;

					// For 3D Standard, try multiple approaches to get buildings working
					if (_this4.type === '3d-standard') {

						// Try approach 1: Use existing composite if available
						if (_this4.map.getSource('composite')) {
							_this4.addBuildingsFromComposite();
							return;
						}

						// Try approach 2: Add Mapbox Streets source
						try {
							if (!_this4.map.getSource('mapbox-streets-buildings')) {
								_this4.map.addSource('mapbox-streets-buildings', {
									'type': 'vector',
									'url': 'mapbox://mapbox.mapbox-streets-v8'
								});
							}
							_this4.addBuildingsFromSource('mapbox-streets-buildings', 'building');
							return;
						} catch (error) {}

						// Try approach 3: Force add buildings with a different approach
						_this4.addAlternativeBuildingsLayer();
						return;
					} else {
						// For other 3D styles, use the standard approach
						if (_this4.map.getSource('composite')) {
							_this4.addBuildingsFromComposite();
						} else {}
					}
				};

				if (this.map.isStyleLoaded()) {
					addBuildingsLayer();
				} else {
					// Use a more robust approach with timeout retries
					var attempts = 0;
					var tryAddBuildings = function tryAddBuildings() {
						attempts++;

						if (_this4.map.isStyleLoaded()) {
							addBuildingsLayer();
						} else if (attempts < 10) {
							// Try again in 500ms
							setTimeout(tryAddBuildings, 500);
						} else {}
					};

					// Start trying after a short delay
					setTimeout(tryAddBuildings, 500);
				}
			} catch (error) {}
		}
	}, {
		key: 'addBuildingsFromComposite',
		value: function addBuildingsFromComposite() {
			this.addBuildingsFromSource('composite', 'building');
		}
	}, {
		key: 'addBuildingsFromSource',
		value: function addBuildingsFromSource(sourceName, sourceLayer) {
			try {
				this.map.addLayer({
					'id': '3d-buildings',
					'source': sourceName,
					'source-layer': sourceLayer,
					'filter': ['==', 'extrude', 'true'],
					'type': 'fill-extrusion',
					'minzoom': 2, // Start at minimum zoom level
					'maxzoom': 18, // Show on more layers - up to max zoom
					'paint': {
						'fill-extrusion-color': ['interpolate', ['linear'], ['get', 'height'], 0, '#cccccc', 50, '#999999', 100, '#666666'],
						'fill-extrusion-height': ['case', ['has', 'height'], ['get', 'height'], ['case', ['>', ['get', 'levels'], 0], ['*', ['get', 'levels'], 3.5], // 3.5m per level
						15 // Default height for buildings without data
						]],
						'fill-extrusion-base': ['case', ['has', 'min_height'], ['get', 'min_height'], 0],
						'fill-extrusion-opacity': 0.8
					}
				});
			} catch (error) {}
		}
	}, {
		key: 'addAlternativeBuildingsLayer',
		value: function addAlternativeBuildingsLayer() {
			try {
				// Try adding a generic building layer that works with any vector source

				// Add OpenStreetMap buildings source as fallback
				if (!this.map.getSource('osm-buildings')) {
					this.map.addSource('osm-buildings', {
						'type': 'vector',
						'url': 'mapbox://mapbox.mapbox-streets-v8'
					});
				}

				this.map.addLayer({
					'id': '3d-buildings',
					'source': 'osm-buildings',
					'source-layer': 'building',
					'type': 'fill-extrusion',
					'minzoom': 2, // Start at minimum zoom level
					'maxzoom': 18, // Show on more layers - up to max zoom
					'paint': {
						'fill-extrusion-color': '#aaa',
						'fill-extrusion-height': ['case', ['has', 'height'], ['get', 'height'], ['case', ['==', ['get', 'building'], 'yes'], 15, 5]],
						'fill-extrusion-base': 0,
						'fill-extrusion-opacity': 0.8
					}
				});
			} catch (error) {}
		}
	}, {
		key: 'setupWeatherLayers',
		value: function setupWeatherLayers() {
			var _this5 = this;

			// Check if weather is enabled and we have layers
			if (!this.settings.weather || !this.settings.weather.enabled || !this.settings.weather.layers || this.settings.weather.layers.length === 0) {
				return;
			}

			// Get API key from global settings
			var apiKey = window.mapsamurai_script_settings && window.mapsamurai_script_settings.weather_api_key;
			if (!apiKey) {
				return;
			}

			// Get opacity (0-1 range)
			var opacity = this.settings.weather.opacity || 0.6;

			// Add each enabled weather layer
			this.settings.weather.layers.forEach(function (layerType) {
				_this5.addWeatherLayer(layerType, apiKey, opacity);
			});
		}
	}, {
		key: 'addWeatherLayer',
		value: function addWeatherLayer(layerType, apiKey, opacity) {
			var _this6 = this;

			// Check if layer already exists
			if (this.weatherLayers[layerType] || this.map.getSource('weather-' + layerType)) {
				return;
			}

			var tileUrl = 'https://tile.openweathermap.org/map/' + layerType + '/{z}/{x}/{y}.png?appid=' + apiKey;

			try {
				// Add source for this weather layer
				this.map.addSource('weather-' + layerType, {
					type: 'raster',
					tiles: [tileUrl],
					tileSize: 256,
					minzoom: 0,
					maxzoom: 18
				});

				// For weather layers, we want them visible but below labels/markers
				// Find the first symbol layer (labels) to insert before
				var layers = this.map.getStyle().layers;
				var firstSymbolId = void 0;
				for (var i = 0; i < layers.length; i++) {
					if (layers[i].type === 'symbol') {
						firstSymbolId = layers[i].id;
						break;
					}
				}

				// Get filter values for this specific layer type
				var filters = this.getWeatherFilterValues(layerType);

				// Add raster layer - insert before first symbol layer (labels), but hidden initially
				this.map.addLayer({
					id: 'weather-' + layerType,
					type: 'raster',
					source: 'weather-' + layerType,
					layout: {
						'visibility': 'none' // Hidden by default - WeatherControls will show when needed
					},
					paint: {
						'raster-opacity': opacity,
						'raster-fade-duration': 0, // Remove fade for faster display
						'raster-brightness-max': filters.brightness,
						'raster-contrast': filters.contrast,
						'raster-saturation': filters.saturation,
						'raster-hue-rotate': filters.hueRotate
					}
				}, firstSymbolId // Insert before labels
				);

				// Store reference
				this.weatherLayers[layerType] = true;

				// Test if the layer is visible
				setTimeout(function () {
					var layer = _this6.map.getLayer('weather-' + layerType);
					var source = _this6.map.getSource('weather-' + layerType);
					if (layer) {}
				}, 1000);
			} catch (error) {}
		}
	}, {
		key: 'removeWeatherLayer',
		value: function removeWeatherLayer(layerType) {
			if (this.weatherLayers[layerType]) {
				try {
					if (this.map.getLayer('weather-' + layerType)) {
						this.map.removeLayer('weather-' + layerType);
					}
					if (this.map.getSource('weather-' + layerType)) {
						this.map.removeSource('weather-' + layerType);
					}
					delete this.weatherLayers[layerType];
				} catch (error) {}
			}
		}
	}, {
		key: 'setWeatherOpacity',
		value: function setWeatherOpacity(opacity) {
			var _this7 = this;

			Object.keys(this.weatherLayers).forEach(function (layerType) {
				try {
					if (_this7.map.getLayer('weather-' + layerType)) {
						_this7.map.setPaintProperty('weather-' + layerType, 'raster-opacity', opacity);
					}
				} catch (error) {}
			});
		}
	}, {
		key: 'getWeatherFilterValues',
		value: function getWeatherFilterValues(layerType) {
			// Check if color adjustments are enabled for this specific layer type
			var colorAdjustmentLayers = this.settings.weather.colorAdjustmentLayers || [];
			if (!colorAdjustmentLayers.includes(layerType)) {
				// Return default values (no adjustment)
				return { brightness: 1, contrast: 0, saturation: 0, hueRotate: 0 };
			}

			var brightness = this.settings.weather.brightness || 1;
			var contrast = this.settings.weather.contrast || 1;
			var saturation = this.settings.weather.saturation || 1;
			var hueRotate = this.settings.weather.hue || 0;

			return { brightness: brightness, contrast: contrast - 1, saturation: saturation - 1, hueRotate: hueRotate };
		}
	}, {
		key: 'applyWeatherFilters',
		value: function applyWeatherFilters(layerType) {
			try {
				if (!this.map.getLayer('weather-' + layerType)) {
					return;
				}

				var filters = this.getWeatherFilterValues(layerType);

				// Mapbox GL doesn't support CSS filters on raster layers directly
				// We need to use raster-brightness-max, raster-contrast, raster-saturation, raster-hue-rotate
				this.map.setPaintProperty('weather-' + layerType, 'raster-brightness-max', filters.brightness);
				this.map.setPaintProperty('weather-' + layerType, 'raster-contrast', filters.contrast);
				this.map.setPaintProperty('weather-' + layerType, 'raster-saturation', filters.saturation);
				this.map.setPaintProperty('weather-' + layerType, 'raster-hue-rotate', filters.hueRotate);
			} catch (error) {}
		}
	}, {
		key: 'showWeatherLayer',
		value: function showWeatherLayer(layerType) {
			var _this8 = this;

			try {
				if (this.map.getLayer('weather-' + layerType)) {
					// Fade in by transitioning opacity from 0 to target
					var targetOpacity = this.map.getPaintProperty('weather-' + layerType, 'raster-opacity') || 0.6;

					// Set opacity to 0 first
					this.map.setPaintProperty('weather-' + layerType, 'raster-opacity', 0);
					this.map.setLayoutProperty('weather-' + layerType, 'visibility', 'visible');

					// Wait for tiles to start loading, then fade in
					setTimeout(function () {
						_this8.map.setPaintProperty('weather-' + layerType, 'raster-opacity-transition', {
							duration: 300,
							delay: 0
						});
						_this8.map.setPaintProperty('weather-' + layerType, 'raster-opacity', targetOpacity);
					}, 100);
				}
			} catch (error) {}
		}
	}, {
		key: 'hideWeatherLayer',
		value: function hideWeatherLayer(layerType) {
			var _this9 = this;

			try {
				if (this.map.getLayer('weather-' + layerType)) {
					// Fade out before hiding
					this.map.setPaintProperty('weather-' + layerType, 'raster-opacity-transition', {
						duration: 300,
						delay: 0
					});
					this.map.setPaintProperty('weather-' + layerType, 'raster-opacity', 0);

					// Hide after fade completes
					setTimeout(function () {
						_this9.map.setLayoutProperty('weather-' + layerType, 'visibility', 'none');
					}, 300);
				}
			} catch (error) {}
		}
	}, {
		key: 'updateWeatherLayerTime',
		value: function updateWeatherLayerTime(layerType, timestamp) {
			var _this10 = this;

			if (!this.weatherLayers[layerType]) {
				return;
			}

			var apiKey = window.mapsamurai_script_settings && window.mapsamurai_script_settings.weather_api_key;
			if (!apiKey) {
				return;
			}

			try {
				var layerId = 'weather-' + layerType;
				var sourceId = 'weather-' + layerType;

				// Get current opacity before removing layer
				var currentOpacity = 0.6;
				if (this.map.getLayer(layerId)) {
					currentOpacity = this.map.getPaintProperty(layerId, 'raster-opacity') || 0.6;

					// Fade out old layer
					this.map.setPaintProperty(layerId, 'raster-opacity-transition', {
						duration: 300,
						delay: 0
					});
					this.map.setPaintProperty(layerId, 'raster-opacity', 0);
				}

				// Wait for fade out, then swap layers
				setTimeout(function () {
					// Remove old layer and source
					if (_this10.map.getLayer(layerId)) {
						_this10.map.removeLayer(layerId);
					}
					if (_this10.map.getSource(sourceId)) {
						_this10.map.removeSource(sourceId);
					}

					var tileUrl = 'https://tile.openweathermap.org/map/' + layerType + '/{z}/{x}/{y}.png?appid=' + apiKey + '&date=' + timestamp;

					_this10.map.addSource(sourceId, {
						type: 'raster',
						tiles: [tileUrl],
						tileSize: 256,
						minzoom: 0,
						maxzoom: 18
					});

					// Find first symbol layer for proper positioning
					var layers = _this10.map.getStyle().layers;
					var firstSymbolId = void 0;
					for (var i = 0; i < layers.length; i++) {
						if (layers[i].type === 'symbol') {
							firstSymbolId = layers[i].id;
							break;
						}
					}

					// Get filter values for this specific layer type
					var filters = _this10.getWeatherFilterValues(layerType);

					// Add new layer with opacity 0
					_this10.map.addLayer({
						id: layerId,
						type: 'raster',
						source: sourceId,
						paint: {
							'raster-opacity': 0,
							'raster-opacity-transition': {
								duration: 300,
								delay: 0
							},
							'raster-brightness-max': filters.brightness,
							'raster-contrast': filters.contrast,
							'raster-saturation': filters.saturation,
							'raster-hue-rotate': filters.hueRotate
						}
					}, firstSymbolId);

					// Fade in new layer after a short delay
					setTimeout(function () {
						_this10.map.setPaintProperty(layerId, 'raster-opacity', currentOpacity);
					}, 100);
				}, 300);
			} catch (error) {}
		}
	}, {
		key: 'findOptimalRouteLayerPosition',
		value: function findOptimalRouteLayerPosition() {
			// Find the best layer to insert routes before
			// Goal: Routes should appear ABOVE all roads/tunnels but BELOW admin boundaries and labels
			// Typical Mapbox layer order: water > land > roads > tunnels > bridges > admin-boundaries > buildings > labels
			var layers = this.map.getStyle().layers;

			// First, try to insert before our own clustering layers
			for (var i = 0; i < layers.length; i++) {
				if (layers[i].id === 'clusters' || layers[i].id === 'cluster-count') {
					return layers[i].id;
				}
			}

			// Look for admin boundary layers (state lines, country borders, etc.)
			// These come AFTER roads, so inserting before them puts routes above roads
			for (var _i = 0; _i < layers.length; _i++) {
				var layer = layers[_i];
				var id = layer.id.toLowerCase();
				if (id.includes('admin') || id.includes('boundary') || id.includes('border')) {
					return layer.id;
				}
			}

			// If no admin layers, insert before building layers
			for (var _i2 = 0; _i2 < layers.length; _i2++) {
				var _layer = layers[_i2];
				var _id = _layer.id.toLowerCase();
				if (_id.includes('building') || _layer.id === '3d-buildings') {
					return _layer.id;
				}
			}

			// Insert before water layers if they exist (this puts routes on top of most things)
			for (var _i3 = 0; _i3 < layers.length; _i3++) {
				var _layer2 = layers[_i3];
				var _id2 = _layer2.id.toLowerCase();
				if (_id2.includes('water') && _layer2.type === 'fill') {
					return _layer2.id;
				}
			}

			// Fallback: insert before the first symbol layer
			for (var _i4 = 0; _i4 < layers.length; _i4++) {
				if (layers[_i4].type === 'symbol') {
					return layers[_i4].id;
				}
			}

			// Last resort: add on top (no beforeLayer)
			return null;
		}
	}, {
		key: 'setupClustering',
		value: function setupClustering() {
			var _this11 = this;

			if (!this.clusteringEnabled) {
				return;
			}

			// Check if clustering is already set up
			if (this.map.getSource('pins')) {
				return;
			}

			// Add clustering source
			this.map.addSource('pins', {
				type: 'geojson',
				data: {
					type: 'FeatureCollection',
					features: []
				},
				cluster: true,
				clusterMaxZoom: 14, // Max zoom to cluster points on
				clusterRadius: 80 // Radius in pixels - larger value merges more aggressively
			});

			// Add cluster circles - add them on top of everything
			try {
				this.map.addLayer({
					id: 'clusters',
					type: 'circle',
					source: 'pins',
					filter: ['has', 'point_count'],
					paint: {
						'circle-color': ['step', ['get', 'point_count'], '#51bbd6', // Light blue for < 10
						10, '#fadf83', // Lighter yellow for 10-99
						100, '#f28cb1' // Pink for >= 100
						],
						'circle-radius': ['step', ['get', 'point_count'], 20, // Small for < 10
						10, 25, // Medium for 10-99
						100, 30 // Large for >= 100
						],
						'circle-opacity': 1.0,
						'circle-stroke-width': 3,
						'circle-stroke-color': 'rgba(255, 255, 255, 0.5)' // 50% opacity white
					}
				}); // Add as topmost layer (no beforeLayer parameter)
			} catch (error) {}

			// Add cluster count labels
			try {
				this.map.addLayer({
					id: 'cluster-count',
					type: 'symbol',
					source: 'pins',
					filter: ['has', 'point_count'],
					layout: {
						'text-field': '{point_count_abbreviated}',
						'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
						'text-size': 14,
						'text-offset': [0, 0],
						'text-anchor': 'center'
					},
					paint: {
						'text-color': '#ffffff'
						// Removed text-halo for cleaner appearance
					}
				}); // Add as topmost layer
			} catch (error) {}

			// Add source for convex hull polygon (shown on cluster hover)
			this.map.addSource('cluster-hull', {
				type: 'geojson',
				data: {
					type: 'FeatureCollection',
					features: []
				}
			});

			// Add polygon fill layer for convex hull
			try {
				this.map.addLayer({
					id: 'cluster-hull-fill',
					type: 'fill',
					source: 'cluster-hull',
					paint: {
						'fill-color': '#51bbd6',
						'fill-opacity': 0.2
					}
				});
			} catch (error) {}

			// Add polygon border layer for convex hull
			try {
				this.map.addLayer({
					id: 'cluster-hull-border',
					type: 'line',
					source: 'cluster-hull',
					paint: {
						'line-color': '#51bbd6',
						'line-width': 2,
						'line-opacity': 0.6
					}
				});
			} catch (error) {}

			// For unclustered points, we'll add individual markers instead of using the layer
			// This allows us to show custom marker images
			// The unclustered points layer is handled in addPinsWithClustering method

			// Click event for clusters
			this.map.on('click', 'clusters', function (e) {
				var features = _this11.map.queryRenderedFeatures(e.point, {
					layers: ['clusters']
				});
				var clusterId = features[0].properties.cluster_id;
				var coords = features[0].geometry.coordinates;

				_this11.map.getSource('pins').getClusterExpansionZoom(clusterId, function (err, zoom) {
					if (err) return;

					// Mapbox returns the zoom AT which the cluster expands,
					// so we need to go +1 past it to actually trigger the expansion
					var targetZoom = zoom + 1;

					_this11.map.easeTo({
						center: coords,
						zoom: targetZoom,
						duration: 500
					});
				});
			});

			// Click event for unclustered points
			this.map.on('click', 'unclustered-point', function (e) {
				var properties = e.features[0].properties;
				var pin = _this11.pins.find(function (p) {
					return p.model.id == properties.id;
				});
				if (pin) {
					_this11.showMarkerTooltip({ _MapSamurai: pin });
				}
			});

			// Change cursor on hover and show convex hull polygon
			this.map.on('mouseenter', 'clusters', function (e) {
				_this11.map.getCanvas().style.cursor = 'pointer';

				// Get cluster information
				var features = _this11.map.queryRenderedFeatures(e.point, {
					layers: ['clusters']
				});

				if (features.length > 0) {
					var clusterId = features[0].properties.cluster_id;
					var pointCount = features[0].properties.point_count;

					// Get all marker coordinates in this cluster
					_this11.map.getSource('pins').getClusterLeaves(clusterId, pointCount, 0, function (err, leaves) {
						if (err || !leaves || leaves.length < 3) return;

						// Extract coordinates from leaves
						var coordinates = leaves.map(function (leaf) {
							return leaf.geometry.coordinates;
						});

						// Calculate convex hull
						var hull = _this11.calculateConvexHull(coordinates);

						// Create polygon feature
						var hullPolygon = {
							type: 'Feature',
							geometry: {
								type: 'Polygon',
								coordinates: [hull.concat([hull[0]])] // Close the polygon
							}
						};

						// Update the hull source
						_this11.map.getSource('cluster-hull').setData({
							type: 'FeatureCollection',
							features: [hullPolygon]
						});
					});
				}
			});

			this.map.on('mouseleave', 'clusters', function () {
				_this11.map.getCanvas().style.cursor = '';

				// Clear the convex hull polygon
				_this11.map.getSource('cluster-hull').setData({
					type: 'FeatureCollection',
					features: []
				});
			});
			this.map.on('mouseenter', 'unclustered-point', function () {
				_this11.map.getCanvas().style.cursor = 'pointer';
			});
			this.map.on('mouseleave', 'unclustered-point', function () {
				_this11.map.getCanvas().style.cursor = '';
			});
		}
	}, {
		key: 'setType',
		value: function setType(type) {
			var _this12 = this;

			if (this.styles[type]) {
				this.type = type;

				// Store weather layer settings before style change
				var weatherEnabled = this.settings.weather && this.settings.weather.enabled;
				var weatherLayers = weatherEnabled ? [].concat(_toConsumableArray(this.settings.weather.layers || [])) : [];

				// Clear weather layers tracking since style change will remove them
				this.weatherLayers = {};

				this.map.setStyle(this.styles[type]);

				// Re-setup 3D features and markers after style change
				this.map.once('style.load', function () {
					_this12.setup3DFeatures();
					_this12.setupClustering();

					// Re-add weather layers with a slight delay to ensure map is ready
					if (weatherEnabled && weatherLayers.length > 0) {
						setTimeout(function () {
							_this12.setupWeatherLayers();
						}, 100);
					}

					// Re-add all markers/pins
					if (_this12.clusteringEnabled && _this12.pins.length > 0) {
						_this12.addPinsWithClustering(_this12.pins);
					} else {
						_this12.readdAllMarkers();
					}
					// Re-add routes
					if (_this12.routes.length > 0) {
						setTimeout(function () {
							_this12.renderRoutesNow(_this12.routes);
						}, 500);
					}
				});
			}
		}
	}, {
		key: 'getCenter',
		value: function getCenter() {
			var center = this.map.getCenter();
			return [center.lat, center.lng];
		}
	}, {
		key: 'setCenter',
		value: function setCenter(center) {
			var _this = this;
			return new Promise(function (resolve) {
				_this.map.once('moveend', resolve);
				_this.map.flyTo({
					center: [center[1], center[0]], // Mapbox uses [lng, lat]
					essential: true
				});
			});
		}
	}, {
		key: 'setZoom',
		value: function setZoom(zoom) {
			var _this = this;
			return new Promise(function (resolve) {
				if (_this.map.getZoom() === zoom) {
					resolve();
					return;
				}
				_this.map.once('zoomend', resolve);
				_this.map.flyTo({
					zoom: zoom,
					essential: true
				});
			});
		}
	}, {
		key: 'getZoom',
		value: function getZoom() {
			return this.map.getZoom();
		}
	}, {
		key: 'addPinWithIcon',
		value: function addPinWithIcon(pin, iconUrl) {
			var _this = this;

			// Get proper dimensions from pin model or image
			var width = pin.model.image.size ? pin.model.image.size[0] : 0;
			var height = pin.model.image.size ? pin.model.image.size[1] : 0;

			// Check if we have explicit size, otherwise get from image
			if (!width && pin.image) {
				width = pin.image.width;
				height = pin.image.height;
			}

			// Handle SVG images that don't have natural dimensions
			var isSvg = iconUrl && iconUrl.toLowerCase().includes('.svg');
			if (isSvg && (!width || !height || width === 0 || height === 0)) {
				// Check if we have custom size from PHP (which includes custom marker width)
				if (pin.model.image.size && pin.model.image.size[0] && pin.model.image.size[1]) {
					width = pin.model.image.size[0];
					height = pin.model.image.size[1];
				} else {
					// Default SVG marker size - can be customized via PHP filter
					width = window.mapsamurai_svg_marker_width || 32;
					height = window.mapsamurai_svg_marker_height || 32;
				}
			}

			// For SVG files, use custom size if available, otherwise apply default limit
			if (isSvg) {
				// If we have custom size from PHP (includes custom marker width), use it
				if (pin.model.image.size && pin.model.image.size[0] && pin.model.image.size[1]) {
					width = pin.model.image.size[0];
					height = pin.model.image.size[1];
				} else if (width > 40) {
					// Only apply 40px limit if no custom size was set
					var aspectRatio = height / width;
					width = 40;
					height = Math.round(width * aspectRatio);
				}
			}

			// Ensure we have valid dimensions
			if (!width || !height) {
				width = 25; // Default marker width
				height = 41; // Default marker height (typical marker shape)
			}

			// Create marker element
			var el = document.createElement('div');
			el.className = 'mapbox-marker';
			el.style.width = width + 'px';
			el.style.height = height + 'px';
			el.style.cursor = 'pointer';

			if (iconUrl) {
				el.style.backgroundImage = 'url(' + iconUrl + ')';
				el.style.backgroundSize = 'contain';
				el.style.backgroundRepeat = 'no-repeat';
				el.style.backgroundPosition = 'center';
			} else {
				// Default marker styling for pins without images
				el.style.backgroundColor = '#3FB1CE';
				el.style.border = '2px solid #fff';
				el.style.borderRadius = '50%';
			}

			// Create Mapbox marker with proper anchor point
			var markerOptions = {
				element: el
			};

			// Use anchor point from PHP if available (bottom center of marker)
			if (pin.model.image.anchor && pin.model.image.anchor.length >= 2) {
				// Convert anchor from pixels to relative position
				var anchorX = pin.model.image.anchor[0] / width; // 0.5 for center
				var anchorY = pin.model.image.anchor[1] / height; // 1.0 for bottom

				// Mapbox uses anchor names, let's set the appropriate one
				if (anchorX >= 0.4 && anchorX <= 0.6 && anchorY >= 0.9) {
					markerOptions.anchor = 'bottom';
				} else if (anchorX >= 0.4 && anchorX <= 0.6) {
					markerOptions.anchor = 'center';
				} else {
					markerOptions.anchor = 'center'; // fallback
				}
			} else {
				// Default to bottom anchor for typical pin markers
				markerOptions.anchor = 'bottom';
			}

			var marker = new mapboxgl.Marker(markerOptions).setLngLat([pin.model.latlng[1], pin.model.latlng[0]]) // [lng, lat]
			.addTo(this.map);

			marker._MapSamurai = pin;
			this.markers.push(marker);

			// Add event listeners - only enable hover on non-mobile devices
			if (!utils.isPhone()) {
				el.addEventListener('mouseover', function (e) {
					var pin = marker._MapSamurai;
					pin.mouseover = true;
					setTimeout(function () {
						pin.mouseover = false;
					});
					_this.showMarkerTooltip(marker);
				});

				el.addEventListener('mouseout', function (e) {
					var pin = marker._MapSamurai;
					var tooltip = pin.tooltip;
					if (!tooltip) {
						return;
					}
					tooltip.node().trigger({
						'type': 'tooltip_mouseout'
					});
				});
			}

			el.addEventListener('click', function (e) {
				var pin = marker._MapSamurai;
				var tooltip = pin.tooltip;

				// Unlock audio on marker click (user gesture)
				_this.unlockAudio();

				var hover = function hover() {
					_this.showMarkerTooltip(marker);
					_this.playHoverAudio(pin);
				};

				var click = function click() {
					$document.trigger('mapsamurai.action.openPopup', {
						value: pin.model.id
					});
				};

				if (tooltip && !tooltip.node().is(':visible')) {
					hover();
					return;
				}
				click();
			});

			// Hide marker if not visible
			if (!pin.isVisible()) {
				marker.remove();
			}
		}
	}, {
		key: 'addPin',
		value: function addPin(pin) {
			var _this = this;

			return new Promise(function (resolve, reject) {
				var onImageLoaded = function onImageLoaded() {
					_this.addPinWithIcon(pin, pin.model.image.url);
					resolve();
				};

				if (pin.model.image.url) {
					if (pin.image.complete) {
						onImageLoaded();
					} else {
						pin.image.onload = onImageLoaded;
						pin.image.onLoad = pin.image.onload;
					}
				} else {
					_this.addPinWithIcon(pin, null);
					resolve();
				}
			});
		}
	}, {
		key: 'addPins',
		value: function addPins(pins) {
			// Store pins for later reference
			this.pins = pins;

			if (this.clusteringEnabled) {
				// Use clustering with GeoJSON
				return this.addPinsWithClustering(pins);
			} else {
				// Use individual markers
				var promises = [];
				for (var i = 0; i < pins.length; i++) {
					var pin = pins[i];
					promises.push(this.addPin(pin));
				}
				return Promise.all(promises);
			}
		}
	}, {
		key: 'addPinsWithClustering',
		value: function addPinsWithClustering(pins) {
			var _this13 = this;

			// Remove any existing markers first
			this.markers.forEach(function (marker) {
				return marker.remove();
			});
			this.markers = [];

			// Remove any existing cluster markers
			if (this.clusterMarkers) {
				this.clusterMarkers.forEach(function (marker) {
					return marker.remove();
				});
			}
			this.clusterMarkers = [];

			// Store pins for reference
			this.pins = pins;

			// Create GeoJSON features for clustering
			var features = pins.map(function (pin) {
				return {
					type: 'Feature',
					properties: {
						id: pin.model.id,
						title: pin.model.title,
						cluster: false,
						iconUrl: pin.image ? pin.image.src : '',
						imageSize: pin.model.image.size || [25, 41]
					},
					geometry: {
						type: 'Point',
						coordinates: [pin.model.latlng[1], pin.model.latlng[0]] // [lng, lat]
					}
				};
			});

			var data = {
				type: 'FeatureCollection',
				features: features
			};

			// Update the clustering source with pin data
			if (this.map.getSource('pins')) {
				this.map.getSource('pins').setData(data);
			}

			// Add individual Mapbox markers for unclustered points
			// These will be dynamically shown/hidden based on clustering
			pins.forEach(function (pin) {
				_this13.addPin(pin);
			});

			// Set up dynamic visibility based on zoom level
			// Use a slight delay to ensure clustering data is processed
			setTimeout(function () {
				_this13.updateMarkerVisibility();
				// Force map to repaint to ensure clusters are visible
				_this13.map.triggerRepaint();
			}, 200);

			return Promise.resolve();
		}
	}, {
		key: 'updateMarkerVisibility',
		value: function updateMarkerVisibility() {
			// This method will hide/show individual markers based on whether they would be clustered
			if (!this.map.getSource('pins') || !this.markers.length) {
				return;
			}

			var zoom = this.map.getZoom();
			var clusterMaxZoom = 14; // Same as clustering setup

			// If we're above cluster max zoom, show all individual markers
			// (no clusters exist at this zoom level)
			if (zoom > clusterMaxZoom) {
				this.markers.forEach(function (marker) {
					marker.getElement().style.display = 'block';
				});
			} else {
				// At cluster zoom levels, hide markers that are part of clusters
				this.hideClusteredMarkers();
			}
		}
	}, {
		key: 'hideClusteredMarkers',
		value: function hideClusteredMarkers() {
			var _this14 = this;

			var source = this.map.getSource('pins');
			if (!source || !this.markers.length) {
				return;
			}

			// Prevent concurrent executions (race condition protection)
			if (this._updatingClusters) {
				return;
			}
			this._updatingClusters = true;

			// Track which pins are currently in clusters
			var clusteredPinIds = new Set();

			// Query all cluster features at current zoom
			var clusterFeatures = this.map.querySourceFeatures('pins', {
				filter: ['has', 'point_count']
			});

			// Collect all promises for getClusterLeaves calls
			var promises = clusterFeatures.map(function (feature) {
				var clusterId = feature.properties.cluster_id;
				var pointCount = feature.properties.point_count;

				return new Promise(function (resolve) {
					source.getClusterLeaves(clusterId, pointCount, 0, function (err, leaves) {
						if (!err && leaves) {
							leaves.forEach(function (leaf) {
								if (leaf.properties && leaf.properties.id) {
									clusteredPinIds.add(leaf.properties.id);
								}
							});
						}
						resolve();
					});
				});
			});

			// Wait for all cluster leaves to be fetched, then update marker visibility
			Promise.all(promises).then(function () {
				// Update each marker's visibility based on whether it's clustered
				_this14.markers.forEach(function (marker) {
					var pinId = marker._MapSamurai.model.id;
					if (clusteredPinIds.has(pinId)) {
						marker.getElement().style.display = 'none';
					} else {
						marker.getElement().style.display = 'block';
					}
				});

				// Release the update lock
				_this14._updatingClusters = false;
			});
		}

		// Calculate convex hull polygon from an array of coordinates
		// Uses Graham Scan algorithm to find the outer boundary

	}, {
		key: 'calculateConvexHull',
		value: function calculateConvexHull(points) {
			// Need at least 3 points to form a polygon
			if (points.length < 3) {
				return points;
			}

			// Find the point with lowest y-coordinate (or leftmost if tie)
			var start = points[0];
			for (var i = 1; i < points.length; i++) {
				if (points[i][1] < start[1] || points[i][1] === start[1] && points[i][0] < start[0]) {
					start = points[i];
				}
			}

			// Sort points by polar angle with respect to start point
			var sorted = points.slice().sort(function (a, b) {
				if (a === start) return -1;
				if (b === start) return 1;

				var angleA = Math.atan2(a[1] - start[1], a[0] - start[0]);
				var angleB = Math.atan2(b[1] - start[1], b[0] - start[0]);

				if (angleA !== angleB) {
					return angleA - angleB;
				}

				// If angles are equal, sort by distance
				var distA = Math.hypot(a[0] - start[0], a[1] - start[1]);
				var distB = Math.hypot(b[0] - start[0], b[1] - start[1]);
				return distA - distB;
			});

			// Build the convex hull
			var hull = [sorted[0], sorted[1]];

			for (var _i5 = 2; _i5 < sorted.length; _i5++) {
				var top = hull[hull.length - 1];
				var nextTop = hull[hull.length - 2];

				// Cross product to determine turn direction
				var cross = (top[0] - nextTop[0]) * (sorted[_i5][1] - nextTop[1]) - (top[1] - nextTop[1]) * (sorted[_i5][0] - nextTop[0]);

				// Remove points that make a right turn
				while (hull.length > 1 && cross <= 0) {
					hull.pop();
					top = hull[hull.length - 1];
					nextTop = hull[hull.length - 2];
					var newCross = (top[0] - nextTop[0]) * (sorted[_i5][1] - nextTop[1]) - (top[1] - nextTop[1]) * (sorted[_i5][0] - nextTop[0]);
					if (newCross > 0) break;
				}

				hull.push(sorted[_i5]);
			}

			return hull;
		}

		// Calculate the optimal zoom level to separate all markers in a cluster

	}, {
		key: 'calculateOptimalClusterZoom',
		value: function calculateOptimalClusterZoom(cluster) {
			if (cluster.length <= 1) {
				return this.map.getZoom() + 2; // Fallback for single markers
			}

			// Calculate bounding box of cluster markers
			var minLat = cluster[0].lngLat.lat;
			var maxLat = cluster[0].lngLat.lat;
			var minLng = cluster[0].lngLat.lng;
			var maxLng = cluster[0].lngLat.lng;

			cluster.forEach(function (pos) {
				minLat = Math.min(minLat, pos.lngLat.lat);
				maxLat = Math.max(maxLat, pos.lngLat.lat);
				minLng = Math.min(minLng, pos.lngLat.lng);
				maxLng = Math.max(maxLng, pos.lngLat.lng);
			});

			// If all markers are at the same location, zoom in significantly
			if (minLat === maxLat && minLng === maxLng) {
				return Math.min(18, this.map.getZoom() + 4); // Zoom in 4 levels, max 18
			}

			// Calculate the bounds and determine appropriate zoom level
			var bounds = new mapboxgl.LngLatBounds([minLng, minLat], [maxLng, maxLat]);

			// Add padding to ensure markers don't touch edges
			var padding = 50;
			var camera = this.map.cameraForBounds(bounds, { padding: padding });

			// Ensure we zoom in at least 1 level from current zoom
			var currentZoom = this.map.getZoom();
			var targetZoom = Math.max(currentZoom + 1, camera.zoom || currentZoom + 2);

			// Ensure we don't exceed reasonable zoom limits
			return Math.min(18, targetZoom);
		}
	}, {
		key: 'readdAllMarkers',
		value: function readdAllMarkers() {
			var _this15 = this;

			// Store pins and animation data before removing markers
			var pins = this.markers.map(function (marker) {
				return marker._MapSamurai;
			}).filter(function (pin) {
				return pin;
			});

			// Store animation data for each animated marker
			var animationData = [];
			if (this.routeAnimator && this.routeAnimator.animatedMarkers) {
				this.markers.forEach(function (marker) {
					if (_this15.routeAnimator.animatedMarkers.has(marker)) {
						var data = _this15.routeAnimator.animatedMarkers.get(marker);
						var pin = marker._MapSamurai;
						if (pin && data) {
							animationData.push({
								pinId: pin.model.id,
								segments: data.segments,
								options: data.options
							});
						}
					}
				});
			}

			// Remove all existing markers (this also removes them from RouteAnimator)
			this.markers.forEach(function (marker) {
				if (_this15.routeAnimator && _this15.routeAnimator.animatedMarkers.has(marker)) {
					_this15.routeAnimator.removeAnimatedMarker(marker);
				}
				marker.remove();
			});
			this.markers = [];

			// Re-add all pins
			return this.addPins(pins).then(function () {
				// Restore animations after markers are recreated
				if (animationData.length > 0) {
					setTimeout(function () {
						animationData.forEach(function (data) {
							// Find the new marker for this pin
							var pin = pins.find(function (p) {
								return p.model.id === data.pinId;
							});
							if (pin) {
								var marker = _this15.getPinMarker(pin);
								if (marker && data.segments && data.segments.length > 0) {
									// Extract waypoints from segments
									var waypoints = data.segments.map(function (seg) {
										return seg.start;
									});
									if (data.segments.length > 0) {
										waypoints.push(data.segments[data.segments.length - 1].end);
									}

									_this15.addAnimatedPin(pin, waypoints, data.options);
								}
							}
						});
					}, 100); // Small delay to ensure markers are fully ready
				}
			});
		}
	}, {
		key: 'showTooltip',
		value: function showTooltip(tooltip, lngLat, anchor) {
			var $win = $(window);
			if (tooltip.node().is(':visible')) {
				return false;
			}

			// Convert map coordinates to screen coordinates
			var point = this.map.project(lngLat);
			var left = this.$canvas.offset().left + point.x - Math.ceil(tooltip.node().width() / 2) + anchor[0];
			var top = this.$canvas.offset().top + point.y - tooltip.node().height() + anchor[1];

			setTimeout(function () {
				tooltip.node().trigger({
					'type': 'tooltip_mouseover',
					'settings': {
						'left': left,
						'top': top
					}
				});
			}, 100);
		}
	}, {
		key: 'hideAllTooltips',
		value: function hideAllTooltips() {
			// Hide all MapSamurai tooltips using the proper tooltip system
			if (window.MapSamuraiTooltip && window.MapSamuraiTooltip._instances) {
				window.MapSamuraiTooltip._instances.forEach(function (tooltip) {
					if (tooltip.visible) {
						// Use the tooltip's own hide method to maintain proper state
						try {
							tooltip.hide();
						} catch (e) {
							// Fallback to manual hide if the tooltip method fails
							tooltip.node().stop().fadeOut(150, function () {
								tooltip.visible = false;
							});
						}
					}
				});
			}

			// Also hide any generic visible tooltips as fallback
			$('[class*="tooltip"]:visible').each(function () {
				var $tooltip = $(this);
				var tooltipData = $tooltip.data('tooltip');
				if (tooltipData && typeof tooltipData.hide === 'function') {
					try {
						tooltipData.hide();
					} catch (e) {
						$tooltip.fadeOut(150);
					}
				} else {
					$tooltip.fadeOut(150);
				}
			});
		}
	}, {
		key: 'showMarkerTooltip',
		value: function showMarkerTooltip(marker) {
			var _this = this;
			var lngLat = marker.getLngLat();
			var pin = marker._MapSamurai;

			// Check if pin has tooltip enabled
			if (!pin.model.tooltipEnabled) {
				return;
			}

			// Always reinitialize the tooltip to prevent corruption issues
			// Get the tooltip settings from the existing tooltip if it exists
			var tooltipSettings = {
				classes: 'mpfy-tooltip',
				rgba: [0, 0, 0, 0.8],
				content: '',
				close_behavior: 'hover',
				animate: true
			};

			if (pin.tooltip) {
				// Extract settings from existing tooltip
				var existingSettings = pin.tooltip.settings;
				if (existingSettings) {
					tooltipSettings = {
						classes: existingSettings.classes || tooltipSettings.classes,
						rgba: existingSettings.rgba || tooltipSettings.rgba,
						content: existingSettings.content || tooltipSettings.content,
						close_behavior: existingSettings.close_behavior || tooltipSettings.close_behavior,
						animate: existingSettings.animate !== undefined ? existingSettings.animate : tooltipSettings.animate
					};
				}

				// Clean up old tooltip
				try {
					pin.tooltip.hide();
					if (pin.tooltip.node) {
						pin.tooltip.node().remove();
					}
				} catch (e) {
					// Ignore cleanup errors
				}
			}

			// Create a fresh tooltip
			var tooltip = new MapSamuraiTooltip(tooltipSettings);
			pin.tooltip = tooltip;

			var anchor = [0, -10];
			if (pin.model.image.url) {
				// Use the same dimension calculation logic as in addPinWithIcon for markers with images
				var width = pin.model.image.size ? pin.model.image.size[0] : 0;
				var height = pin.model.image.size ? pin.model.image.size[1] : 0;

				// Check if we have explicit size, otherwise get from image
				if (!width && pin.image) {
					width = pin.image.width;
					height = pin.image.height;
				}

				// Handle SVG images that don't have natural dimensions
				var isSvg = pin.model.image.url.toLowerCase().includes('.svg');
				if (isSvg && (!width || !height || width === 0 || height === 0)) {
					// Check if we have custom size from PHP (which includes custom marker width)
					if (pin.model.image.size && pin.model.image.size[0] && pin.model.image.size[1]) {
						width = pin.model.image.size[0];
						height = pin.model.image.size[1];
					} else {
						// Default SVG marker size - can be customized via PHP filter
						width = window.mapsamurai_svg_marker_width || 32;
						height = window.mapsamurai_svg_marker_height || 32;
					}
				}

				// For SVG files, use custom size if available, otherwise apply default limit
				if (isSvg) {
					// If we have custom size from PHP (includes custom marker width), use it
					if (pin.model.image.size && pin.model.image.size[0] && pin.model.image.size[1]) {
						width = pin.model.image.size[0];
						height = pin.model.image.size[1];
					} else if (width > 40) {
						// Only apply 40px limit if no custom size was set
						var aspectRatio = height / width;
						width = 40;
						height = Math.round(width * aspectRatio);
					}
				}

				// Ensure we have valid dimensions
				if (!width || !height) {
					width = 25; // Default marker width
					height = 41; // Default marker height (typical marker shape)
				}

				// Use the processed height for tooltip positioning
				anchor[1] -= height + 5;
			} else {
				// For markers without images, use simple fixed positioning
				anchor[1] = -45; // Fixed offset for default markers
			}

			if (utils.isPhone()) {
				// Position marker at bottom center of map, with tooltip appearing above
				var offset = 80; // fixed pixel offset from center

				var markerPoint = _this.map.project(lngLat);
				var targetPoint = [markerPoint.x, markerPoint.y - offset];
				var targetLngLat = _this.map.unproject(targetPoint);

				_this.map.flyTo({
					center: targetLngLat,
					essential: true
				});

				setTimeout(function () {
					_this.showTooltip(tooltip, lngLat, anchor);
				}, 300);
			} else {
				_this.showTooltip(tooltip, lngLat, anchor);
			}
		}
	}, {
		key: 'geocode',
		value: function geocode(query) {
			// Use Mapbox Geocoding API
			var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + encodeURIComponent(query) + '.json?access_token=' + this.accessToken;

			return fetch(url).then(function (response) {
				return response.json();
			}).then(function (data) {
				var filteredResults = [];
				if (data.features) {
					for (var i = 0; i < data.features.length; i++) {
						var feature = data.features[i];
						var coords = feature.center;
						filteredResults.push(new GeocodingResult(feature.place_name, coords[1], coords[0]));
					}
				}
				return Promise.resolve(filteredResults);
			});
		}
	}, {
		key: 'getPinsWithinRange',
		value: function getPinsWithinRange(lat, lng, rangeInMeters) {
			var _this = this;
			var target = [lng, lat]; // Mapbox uses [lng, lat]
			return this.markers.filter(function (marker) {
				var markerLngLat = marker.getLngLat();
				var distance = _this.getDistance([markerLngLat.lat, markerLngLat.lng], [lat, lng]);
				return distance <= rangeInMeters;
			}).map(function (marker) {
				return marker._MapSamurai;
			});
		}
	}, {
		key: 'getDistance',
		value: function getDistance(coord1, coord2) {
			// Haversine formula for distance calculation
			var R = 6371e3; // Earth's radius in meters
			var φ1 = coord1[0] * Math.PI / 180;
			var φ2 = coord2[0] * Math.PI / 180;
			var Δφ = (coord2[0] - coord1[0]) * Math.PI / 180;
			var Δλ = (coord2[1] - coord1[1]) * Math.PI / 180;

			var a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
			var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

			return R * c;
		}
	}, {
		key: 'getPinClosestTo',
		value: function getPinClosestTo(lat, lng) {
			var lowestDistance = -1;
			var closestPin = null;

			for (var i = 0; i < this.markers.length; i++) {
				var marker = this.markers[i];
				var markerLngLat = marker.getLngLat();
				var distance = this.getDistance([markerLngLat.lat, markerLngLat.lng], [lat, lng]);
				if (lowestDistance < 0 || distance < lowestDistance) {
					lowestDistance = distance;
					closestPin = marker._MapSamurai;
				}
			}
			return closestPin;
		}
	}, {
		key: 'getPinDistance',
		value: function getPinDistance(lat, lng, pin) {
			var marker = this.getPinMarker(pin);
			var markerLngLat = marker.getLngLat();
			return this.getDistance([markerLngLat.lat, markerLngLat.lng], [lat, lng]);
		}

		// Audio management methods

	}, {
		key: 'unlockAudio',
		value: function unlockAudio() {
			var _this16 = this;

			if (this.audioUnlocked) return;

			// Create a silent audio element and attempt to play it to unlock audio context
			try {
				var silentAudio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmEeCC2L0fPSezQCHnrC6+OWRgsVXKvy1KhTEAg+ltryzoAgByt+0e3egTAFHHfJ7N2QQAoUXKvy05lPEQ1FAAA=');
				silentAudio.volume = 0.01;
				silentAudio.play().then(function () {
					_this16.audioUnlocked = true;
				}).catch(function () {
					// Silent fail - will try again on next interaction
				});
			} catch (e) {
				// Silent fail
			}
		}
	}, {
		key: 'createAudioPlayer',
		value: function createAudioPlayer(pin) {
			if (!pin.model.hoverAudio || pin.audioElement) {
				return;
			}

			pin.audioElement = new Audio(pin.model.hoverAudio);
			pin.audioElement.preload = 'metadata';
			pin.audioElement.volume = 0.7; // Set to 70% volume

			// Handle audio loading errors
			pin.audioElement.onerror = function () {
				pin.audioElement = null;
			};
		}
	}, {
		key: 'playHoverAudio',
		value: function playHoverAudio(pin) {
			// Unlock audio on hover (before attempting to play)
			this.unlockAudio();

			// Stop any currently playing audio
			this.stopAllHoverAudio();

			if (!pin.model.hoverAudio) {
				return;
			}

			// Create audio element if it doesn't exist
			this.createAudioPlayer(pin);

			if (pin.audioElement) {
				pin.audioElement.currentTime = 0; // Start from beginning
				pin.audioElement.play().catch(function (error) {
					// Silently handle playback failure
				});
			}
		}
	}, {
		key: 'stopHoverAudio',
		value: function stopHoverAudio(pin) {
			if (pin.audioElement) {
				pin.audioElement.pause();
				pin.audioElement.currentTime = 0;
			}
		}
	}, {
		key: 'stopAllHoverAudio',
		value: function stopAllHoverAudio() {
			for (var i = 0; i < this.markers.length; i++) {
				var marker = this.markers[i];
				var pin = marker._MapSamurai;
				this.stopHoverAudio(pin);
			}
		}
	}, {
		key: 'highlightPin',
		value: function highlightPin(pin) {
			var _this17 = this;

			var _this = this;
			var marker = this.getPinMarker(pin);
			if (!marker) {
				return Promise.resolve();
			}

			return Promise.resolve().then(function () {
				var promises = _this17.markers.map(function (marker) {
					var currentPin = marker._MapSamurai;
					currentPin.setVisibility('base', true);
					return _this.updatePinVisibility(currentPin);
				});

				return Promise.all(promises);
			}).then(function () {
				var lngLat = marker.getLngLat();
				return _this.setCenter([lngLat.lat, lngLat.lng]);
			}).then(function () {
				return _this.showMarkerTooltip(marker);
			});
		}
	}, {
		key: 'getPinMarker',
		value: function getPinMarker(pin) {
			for (var i = 0; i < this.markers.length; i++) {
				var marker = this.markers[i];
				if (marker._MapSamurai === pin) {
					return marker;
				}
			}
			return null;
		}
	}, {
		key: 'fitPins',
		value: function fitPins(pins) {
			var _this = this;
			if (pins.length === 0) {
				return Promise.resolve();
			}

			var coordinates = pins.map(function (pin) {
				return [pin.model.latlng[1], pin.model.latlng[0]]; // [lng, lat]
			});

			var bounds = coordinates.reduce(function (bounds, coord) {
				return bounds.extend(coord);
			}, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

			return new Promise(function (resolve) {
				_this.map.once('moveend', resolve);
				_this.map.fitBounds(bounds, {
					padding: 50,
					maxZoom: _this.map.getZoom()
				});
			});
		}
	}, {
		key: 'updatePinVisibility',
		value: function updatePinVisibility(pin) {
			var _this18 = this;

			var marker = this.getPinMarker(pin);
			if (!marker) {
				return Promise.resolve();
			}

			return new Promise(function (resolve) {
				if (pin.isVisible()) {
					if (!marker.getElement().parentNode) {
						marker.addTo(_this18.map);
					}
				} else {
					marker.remove();
				}
				resolve();
			});
		}
	}, {
		key: 'locate',
		value: function locate() {
			var _this = this;
			return new Promise(function (resolve, reject) {
				if (!navigator.geolocation) {
					reject(new Error('Geolocation not supported'));
					return;
				}

				navigator.geolocation.getCurrentPosition(function (position) {
					var coords = [position.coords.latitude, position.coords.longitude];

					// Use a single flyTo call to set both center and zoom
					_this.map.once('moveend', function () {
						resolve(coords);
					});

					_this.map.flyTo({
						center: [coords[1], coords[0]], // Mapbox uses [lng, lat]
						zoom: 15,
						essential: true
					});
				}, function (error) {
					reject(error);
				}, {
					enableHighAccuracy: true,
					timeout: 10000,
					maximumAge: 60000
				});
			});
		}
	}, {
		key: 'redraw',
		value: function redraw() {
			this.map.resize();
		}
	}, {
		key: 'addRoutes',
		value: function addRoutes(routes) {
			var _this19 = this;

			if (!routes || routes.length === 0) {
				return;
			}

			// Store routes for later use (e.g., when style changes)
			this.routes = routes;

			// Wait for map to be loaded before adding routes
			if (!this.map.loaded()) {
				// Map not loaded yet, routes will be added in the 'load' event
				return;
			}

			// Add a small delay to ensure map is fully ready
			setTimeout(function () {
				_this19.renderRoutesNow(routes);
			}, 100);
		}
	}, {
		key: 'renderRoutesNow',
		value: function renderRoutesNow(routes) {
			var _this20 = this;

			routes.forEach(function (route, index) {
				if (!route.waypoints || route.waypoints.length === 0) return;

				var coordinates = route.waypoints.map(function (wp) {
					return [wp.lng, wp.lat];
				}); // Mapbox uses [lng, lat]
				var routeId = 'route-' + index;
				var sourceId = 'route-source-' + index;

				if (route.type === 'custom') {
					// Add custom polyline route

					try {
						// Remove existing source/layer if they exist
						if (_this20.map.getLayer(routeId)) {
							_this20.map.removeLayer(routeId);
						}
						if (_this20.map.getSource(sourceId)) {
							_this20.map.removeSource(sourceId);
						}

						_this20.map.addSource(sourceId, {
							'type': 'geojson',
							'data': {
								'type': 'Feature',
								'properties': {},
								'geometry': {
									'type': 'LineString',
									'coordinates': coordinates
								}
							}
						});

						// Find a good layer to insert before (to control z-index)
						var beforeLayer = _this20.findOptimalRouteLayerPosition();

						_this20.map.addLayer({
							'id': routeId,
							'type': 'line',
							'source': sourceId,
							'layout': {
								'line-join': 'round',
								'line-cap': 'round'
							},
							'paint': {
								'line-color': route.color || '#3a6fac',
								'line-width': parseInt(route.width) || 5
							}
						}, beforeLayer);
					} catch (error) {}
				} else if (route.type === 'automatic' && coordinates.length >= 2) {
					// Use Mapbox Directions API for automatic routing

					// Remove existing source/layer if they exist
					try {
						if (_this20.map.getLayer(routeId)) {
							_this20.map.removeLayer(routeId);
						}
						if (_this20.map.getSource(sourceId)) {
							_this20.map.removeSource(sourceId);
						}
					} catch (error) {}

					var directionsUrl = 'https://api.mapbox.com/directions/v5/mapbox/driving/' + coordinates.map(function (coord) {
						return coord.join(',');
					}).join(';') + '?geometries=geojson&access_token=' + _this20.accessToken;

					fetch(directionsUrl).then(function (response) {
						return response.json();
					}).then(function (data) {

						if (data.routes && data.routes.length > 0) {
							var routeGeometry = data.routes[0].geometry;

							// Find appropriate layer to insert before (control z-index)
							var _beforeLayer = _this20.findOptimalRouteLayerPosition();

							_this20.map.addSource(sourceId, {
								'type': 'geojson',
								'data': {
									'type': 'Feature',
									'properties': {},
									'geometry': routeGeometry
								}
							});

							// Use the beforeLayer from the outer scope
							_this20.map.addLayer({
								'id': routeId,
								'type': 'line',
								'source': sourceId,
								'layout': {
									'line-join': 'round',
									'line-cap': 'round'
								},
								'paint': {
									'line-color': route.color || '#3a6fac',
									'line-width': parseInt(route.width) || 5
								}
							}, _beforeLayer);
						} else {
							_this20.addFallbackRoute(sourceId, routeId, coordinates, route);
						}
					}).catch(function (error) {
						_this20.addFallbackRoute(sourceId, routeId, coordinates, route);
					});
				}
			});
		}
	}, {
		key: 'addFallbackRoute',
		value: function addFallbackRoute(sourceId, routeId, coordinates, route) {
			// Fallback to simple line when Directions API fails

			try {
				// Find appropriate layer to insert before
				var beforeLayer = this.findOptimalRouteLayerPosition();

				this.map.addSource(sourceId, {
					'type': 'geojson',
					'data': {
						'type': 'Feature',
						'properties': {},
						'geometry': {
							'type': 'LineString',
							'coordinates': coordinates
						}
					}
				});

				this.map.addLayer({
					'id': routeId,
					'type': 'line',
					'source': sourceId,
					'layout': {
						'line-join': 'round',
						'line-cap': 'round'
					},
					'paint': {
						'line-color': route.color || '#3a6fac',
						'line-width': parseInt(route.width) || 5
					}
				}, beforeLayer);
			} catch (error) {}
		}

		/**
   * Move marker to a specific position (for route animation)
   * @param {Object} marker - Mapbox marker
   * @param {Object} position - {lat, lng} position
   */

	}, {
		key: 'moveMarkerToPosition',
		value: function moveMarkerToPosition(marker, position) {
			if (marker && marker.setLngLat) {
				marker.setLngLat([position.lng, position.lat]); // Mapbox uses [lng, lat] order
			}
		}

		/**
   * Hide marker during animation delay
   * @param {Object} marker - Mapbox marker
   */

	}, {
		key: 'hideMarkerDuringDelay',
		value: function hideMarkerDuringDelay(marker) {
			if (marker && marker.getElement) {
				var element = marker.getElement();
				if (element) {
					element.style.opacity = '0';
				}
			}
		}

		/**
   * Show marker after animation delay
   * @param {Object} marker - Mapbox marker
   */

	}, {
		key: 'showMarkerAfterDelay',
		value: function showMarkerAfterDelay(marker) {
			if (marker && marker.getElement) {
				var element = marker.getElement();
				if (element) {
					element.style.visibility = 'visible';
					element.style.display = 'block';
					element.style.opacity = '1';
				}
			}
		}

		/**
   * Setup animation for a pin along a route
   * @param {Object} pin - Pin object with marker and route data
   * @param {Array} routeWaypoints - Route waypoints
   * @param {Object} animationOptions - Animation settings
   */

	}, {
		key: 'addAnimatedPin',
		value: function addAnimatedPin(pin, routeWaypoints, animationOptions) {
			var _this21 = this;

			// Check if map is loaded
			if (!this.map.loaded()) {
				this.pendingAnimations.push({ pin: pin, routeWaypoints: routeWaypoints, animationOptions: animationOptions });
				return;
			}

			var marker = this.getPinMarker(pin);
			if (!marker || !routeWaypoints || routeWaypoints.length < 2) {
				return;
			}

			// If there's a delay, position marker at route start and set up fade-in
			if (animationOptions.delay && animationOptions.delay > 0 && routeWaypoints.length > 0) {
				var startPoint = routeWaypoints[0];
				if (startPoint && startPoint.lat && startPoint.lng) {
					marker.setLngLat([startPoint.lng, startPoint.lat]); // Mapbox uses [lng, lat] order
				}

				// Hide marker during delay
				var element = marker.getElement();
				if (element) {
					element.style.opacity = '0';
					element.style.visibility = 'hidden';
					element.style.display = 'none';
				}
			}

			// Store original event handlers
			var originalMouseEnter = marker._element && marker._element.onmouseenter;
			var originalMouseLeave = marker._element && marker._element.onmouseleave;

			// Set up hover pause functionality
			if (marker._element) {
				marker._element.onmouseenter = function (e) {
					// Pause animation
					if (_this21.routeAnimator) {
						_this21.routeAnimator.pauseMarker(marker);
					}
					// Play hover audio
					_this21.playHoverAudio(marker._MapSamurai);
					// Call original handler
					if (originalMouseEnter) {
						originalMouseEnter.call(marker._element, e);
					}
				};

				marker._element.onmouseleave = function (e) {
					// Stop hover audio
					_this21.stopHoverAudio(marker._MapSamurai);
					// Resume animation after delay
					setTimeout(function () {
						if (_this21.routeAnimator) {
							_this21.routeAnimator.resumeMarker(marker);
						}
					}, 100);
					// Call original handler
					if (originalMouseLeave) {
						originalMouseLeave.call(marker._element, e);
					}
				};
			}

			// Add to route animator (now always available since we initialize it immediately)
			this.routeAnimator.addAnimatedMarker(marker, routeWaypoints, animationOptions);
		}

		/**
   * Remove animation for a pin
   * @param {Object} pin - Pin object
   */

	}, {
		key: 'removeAnimatedPin',
		value: function removeAnimatedPin(pin) {
			var marker = this.getPinMarker(pin);
			if (marker && this.routeAnimator) {
				this.routeAnimator.removeAnimatedMarker(marker);
			}
		}

		/**
   * Fetch current temperature for coordinates using OpenWeatherMap API
   * @param {number} lat - Latitude
   * @param {number} lng - Longitude
   * @param {string} format - Temperature format ('fahrenheit' or 'celsius')
   * @returns {Promise<Object>} Temperature data with current, high, low, and format
   */

	}, {
		key: 'fetchCurrentTemperature',
		value: function fetchCurrentTemperature(lat, lng) {
			var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'fahrenheit';

			var apiKey = '735a344e3f83e55094c82850dacd3816';
			var units = format === 'celsius' ? 'metric' : 'imperial';
			var url = 'https://api.openweathermap.org/data/2.5/weather?lat=' + lat + '&lon=' + lng + '&appid=' + apiKey + '&units=' + units;

			return fetch(url).then(function (response) {
				if (!response.ok) {
					throw new Error('Weather API error: ' + response.status);
				}
				return response.json();
			}).then(function (data) {
				if (data && data.main && typeof data.main.temp === 'number') {
					return {
						current: data.main.temp,
						high: data.main.temp_max,
						low: data.main.temp_min,
						format: format
					};
				}
				throw new Error('Invalid weather data format');
			}).catch(function (error) {
				console.error('Failed to fetch temperature:', error);
				throw error;
			});
		}

		/**
   * Check if route animation is supported
   * @returns {boolean}
   */

	}, {
		key: 'supportsRouteAnimation',
		value: function supportsRouteAnimation() {
			return true;
		}
	}]);

	return MapboxGLMapService;
}(MapService);

module.exports = MapboxGLMapService;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/map-services/mapbox-gl-map-service.js
// module id = 18
// module chunks = 0